import React, { useEffect, useState } from 'react';
import { Flex, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface LoadingStateProps {
  analyzedCount: number;
  remainingCount: number;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  analyzedCount,
  remainingCount
}) => {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setElapsedSeconds(prev => prev + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Flex
      vertical
      justify="center"
      align="center"
      style={{ padding: '24px 0' }}
      gap="middle"
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />} />
      <Flex vertical align="center" gap="small">
        <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
          Analyzing selected test-takers...
        </span>
        <span style={{ color: '#595959' }}>
          Analyzed: {analyzedCount} | Remaining: {remainingCount}
        </span>
        <span style={{ color: '#8c8c8c', fontSize: '12px' }}>
          Time elapsed: {elapsedSeconds}s
        </span>
      </Flex>
    </Flex>
  );
};
